import React from "react";

import { Privacy, Terms } from "./Links";

const SignupLinks = () => {
  return (
    <div className="component-after">
      <p className="small text-center pr-2 pl-2">
        By signing up to Moshi you are agreeing to our
        <br />
        <Terms /> {" & "}
        <Privacy />
      </p>
    </div>
  );
};

export default SignupLinks;
